import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { Button } from '../../components/styled/Button/Button'
import { updateSolarIntent } from '../../store/lead/leadSlice'
import { Progress } from '../../@types/progress'
import { ReduxState } from '../../store/reducers'
import { SolarIntent, solarIntentGermanString } from '../../@types/solarIntent'
import { SolarIntentStepIcon } from '../../components/icons/StepIcons/SolarIntentStepIcon'
import { useReportViewEvent } from '../../hooks'
import { reportTrackingEvent } from '../../tracking/thunks'

interface SolarIntentStepProps {
  goToNextStep: () => unknown
  goToPreviousStep: () => unknown
  progress: Progress
  displayBack: boolean
}

const headline = 'Wie möchtest du die Solaranlage finanzieren?'

const SolarIntentStep: FC<SolarIntentStepProps> = (props) => {
  const {
    config: { theme },
  } = useSelector((state: ReduxState) => state)

  const dispatch = useDispatch()

  useReportViewEvent({ pageTitle: 'financing' })

  const goToNextStep = (solarIntent: SolarIntent) => {
    dispatch(updateSolarIntent(solarIntent))
    dispatch(
      reportTrackingEvent({
        pageTitle: 'financing',
        label: 'financing_submit',
        eventName: 'lead_input',
        inputValue: solarIntent,
        customDimensions: { ga_cd_lead_engine_input_value: solarIntent },
        action: 'solar-leadengine',
        category: 'residential',
        flow: 'sle',
      })
    )
    props.goToNextStep()
  }

  return (
    <StepTemplate
      icon={<SolarIntentStepIcon />}
      headline={headline}
      displayNext={false}
      goToPreviousStep={props.goToPreviousStep}
      progress={props.progress}
      displayBack={props.displayBack}
      backgroundColor={theme.background}
      textColor={theme.text}
    >
      {Object.entries(solarIntentGermanString).map(([key, label]) => (
        <Button
          key={key}
          text={label}
          onClick={() => goToNextStep(key as SolarIntent)}
          className='margin-right-m margin-bottom-xl'
          dataTesting={`option-${key}`}
          backgroundColor={theme.background}
          color={theme.text}
          borderColor={theme.secondary}
        />
      ))}
    </StepTemplate>
  )
}

export default SolarIntentStep
